// Zaman yardımcıları — App.js, OrderCard.js, DoneCard.js tarafından kullanılır

// DB UTC timestamp "2026-03-15 01:45:50" → "2026-03-15T01:45:50Z" (UTC olarak parse)
function parseUtc(dateStr) {
  return new Date(dateStr.replace(" ", "T") + "Z");
}

export function timeAgo(dateStr) {
  const diff = Math.floor((Date.now() - parseUtc(dateStr).getTime()) / 1000);
  if (diff < 60) return `${diff}sn`;
  if (diff < 3600) return `${Math.floor(diff / 60)}dk`;
  return `${Math.floor(diff / 3600)}sa`;
}

export function formatTime(dateStr) {
  return parseUtc(dateStr).toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Istanbul",
  });
}

export function playNewOrderSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const now = ctx.currentTime;
    const notes = [523.25, 659.25, 783.99]; // C5-E5-G5
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, now + i * 0.12);
      gain.gain.setValueAtTime(0, now + i * 0.12);
      gain.gain.linearRampToValueAtTime(0.35, now + i * 0.12 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.12 + 0.4);
      osc.start(now + i * 0.12);
      osc.stop(now + i * 0.12 + 0.5);
    });
  } catch (e) {
    console.warn("Audio failed:", e);
  }
}

// Admin panelinden seçilebilen 5 farklı alarm sesi.
// playNewOrderSound() geriye dönük uyumluluk için korunur.
export function playAlarmSound(soundName = "classic_ding") {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;

    const tone = (freq, start, dur, type = "sine", vol = 0.35) => {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = type;
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(vol, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, now + start + dur);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.05);
    };

    switch (soundName) {
      case "classic_ding":
        // C5 → E5 → G5 (mevcut playNewOrderSound ile aynı)
        [523.25, 659.25, 783.99].forEach((f, i) => tone(f, i * 0.12, 0.4));
        break;

      case "soft_bell":
        // 600 Hz tek yumuşak ton, uzun decay
        tone(600, 0, 0.8, "sine", 0.25);
        break;

      case "digital_pop":
        // Hızlı square wave burst — iki kısa bip
        tone(880, 0,    0.07, "square", 0.2);
        tone(880, 0.10, 0.07, "square", 0.2);
        break;

      case "kitchen_ping":
        // 1050 Hz yüksek ping, uzun çınlama
        tone(1050, 0, 1.0, "sine", 0.3);
        break;

      case "double_beep":
        // 800 Hz iki bip, aralıklı
        tone(800, 0,    0.15, "sine", 0.35);
        tone(800, 0.25, 0.15, "sine", 0.35);
        break;

      default:
        // Tanınmayan ses adı → classic_ding fallback
        [523.25, 659.25, 783.99].forEach((f, i) => tone(f, i * 0.12, 0.4));
    }
  } catch (e) {
    console.warn("Audio failed:", e);
  }
}
